import { useQuery } from '@tanstack/react-query'
import { statistikApi } from '../lib/client'
import { ApiResponse, StatistikPekerjaan } from '../../../shared-lib/types'

export function usePekerjaanStats() {
    return useQuery<ApiResponse<StatistikPekerjaan>>({
        queryKey: ['statistik', 'pekerjaan'],
        queryFn: async () => {
            try {
                return await statistikApi.getPekerjaan()
            } catch (error) {
                const errorResponse: ApiResponse<StatistikPekerjaan> = {
                    status: "error",
                    message: error instanceof Error ? error.message : "Gagal mengambil data statistik pekerjaan",
                    data: {
                        totalPenduduk: 0,
                        pekerjaan: []
                    }
                }
                
                console.error('Error fetching pekerjaan statistics:', error)
                throw errorResponse
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
    })
}
